import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { MarkupAction } from '@cbridge-packages/markup';
import { MultiSelectSidebarAction } from '@cbridge-packages/multi-select-sidebar';

export const closeBulkEditSidebarOnDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    MarkupAction.bulkUpdate.done,
    MarkupAction.bulkRemove.done,
  ),
  mergeMap(() => [
    MultiSelectSidebarAction.closeBulkEditSidebar(),
    MultiSelectSidebarAction.clearSelection(),
  ]),
);
